module.exports = __webpack_public_path__ + "img/182.6cf8a1c7.jpg";